import fileUpload from "./fileUpload";
import fileDownload from "./fileDownload";
import surveyFileUpload from "./surveyFileUpload";
import getFileViaId from "./getFileViaId";
import uploadFileByUrl from "./uploadFileByUrl";
import updateFileAttachmentStatus from "./updateFileAttachmentStatus";
const file = {
  fileUpload,
  fileDownload,
  surveyFileUpload,
  getFileViaId,
  uploadFileByUrl,
  updateFileAttachmentStatus,
};

export default file;
